import { AutomationStep } from '@/types/automationSteps.ts';
import { StepErrorType } from '@/types/stepErrorTypes.ts';
import useIsNewStep from '@/hooks/useIsNewStep.ts';
import { Alert, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import React, { useMemo } from 'react';

type Props = {
  step: AutomationStep;
};

const formatIssueMessage = (message: string, index: number | null) => {
  return index === null ? message : `Output ${index + 1}: ${message}`;
};

const SchemaStepIssues = ({ step }: Props) => {
  const isNewStep = useIsNewStep(step.step_id);
  const schemaIssues = useMemo(
    () =>
      isNewStep
        ? []
        : step.errors.filter((error) => error.type === StepErrorType.InvalidSchemaRef),
    [isNewStep, step.errors],
  );

  if (schemaIssues.length === 0) {
    return null;
  }

  return (
    <Alert color="yellow" variant="light" icon={<IconAlertTriangle size={16} />}>
      <Stack gap={4}>
        <Text size="12px" fw={500}>
          Schema issue{schemaIssues.length === 1 ? '' : 's'}
        </Text>
        {schemaIssues.map((issue, index) => (
          <Text key={`${issue.message}-${index}`} size="12px">
            {formatIssueMessage(issue.message, issue.index)}
          </Text>
        ))}
      </Stack>
    </Alert>
  );
};

export default SchemaStepIssues;
